import BLOG_POSTS_1, { BlogPost } from './blog-posts-1';
import BLOG_POSTS_2 from './blog-posts-2';
import BLOG_POSTS_3 from './blog-posts-3';
import BLOG_POSTS_4 from './blog-posts-4';
import BLOG_POSTS_5 from './blog-posts-5';

export type { BlogPost };

const ALL_BLOG_POSTS: BlogPost[] = [
  ...BLOG_POSTS_1,
  ...BLOG_POSTS_2,
  ...BLOG_POSTS_3,
  ...BLOG_POSTS_4,
  ...BLOG_POSTS_5,
].sort((a, b) => b.date.localeCompare(a.date));

export default ALL_BLOG_POSTS;
